import React from "react";
import { Link, useLocation } from "react-router-dom";

// Text wordmark that preserves the brand's thin serif lettering.
export function Logo({ light = false, className = "", showTagline = true }) {
  const location = useLocation();
  const fischer = light ? "text-cream-100" : "text-ink";
  const tagline = light ? "text-cream-100/70" : "text-steel-600";
  const onClick = () => {
    if (location.pathname === "/") window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Link to="/" onClick={onClick} className={`inline-flex flex-col leading-none ${className}`} data-testid="site-logo">
      <span className="font-serif font-medium tracking-tight text-[1.7rem] sm:text-[2rem]">
        <span className="text-gold-600">Goldman</span>
        <span className={`ml-2 ${fischer}`}>Fischer</span>
      </span>
      {showTagline && (
        <span className={`mt-1 font-sans uppercase tracking-[0.28em] text-[0.5rem] sm:text-[0.55rem] ${tagline}`}>
          Strategic Planning&nbsp;&middot;&nbsp;Consultants &amp; Advisors
        </span>
      )}
    </Link>
  );
}
